import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./AdminSearchWidget.module.scss";

type Props = {
  handleSearch: (search: Array<string>) => void;
  search: Array<string>;
};

const AdminSearchWidget: React.FC<Props> = ({ handleSearch, search }) => {
  const [inputValue, setInputValue] = useState<string>("");

  const handleSubmit = () => {
    if (inputValue === "") {
      return;
    }

    const s = search;
    s.push(inputValue);
    handleSearch(s);
    setInputValue("");
  };

  const deleteKeyword = (i: number) => {
    const newSearch = search.filter((v, index) => index !== i);
    setInputValue("");

    handleSearch(newSearch);
  };

  const resetSearch = () => {
    setInputValue("");
    handleSearch([]);
  };

  const handlePushEnter = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();

      handleSubmit();
    }
  };

  return (
    <div className={styles["f-listFilter"]}>
      <div className={styles["f-listFilter__terms"]}>
        <div className={styles["f-listFilter__terms-tags"]}>
          {search.map((el, i) => (
            <li key={i}>
              {el}
              <FontAwesomeIcon
                icon={["fas", "times-circle"]}
                onClick={() => deleteKeyword(i)}
              />
            </li>
          ))}
        </div>
      </div>
      {/* <div className={styles["f-listFilter__criteria-btn"]}>
          <FontAwesomeIcon icon={["fal", "filter"]} />
          絞り込み
        </div> */}
      <button
        type="button"
        onClick={resetSearch}
        className={styles["f-listFilter__criteria-btn"]}
      >
        <FontAwesomeIcon icon={["fal", "sync"]} />
        条件リセット
      </button>
      <div className={styles["f-listFilter__criteria-search"]}>
        <div className={styles["f-listFilter__criteria-search-input"]}>
          <input
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              if (
                event.target.value !== undefined &&
                typeof event.target.value === "string"
              ) {
                setInputValue(event.target.value);
              }
            }}
            type="text"
            name="search"
            placeholder="フリーワード検索"
            value={inputValue}
            onKeyPress={(e) => handlePushEnter(e)}
          />
        </div>
        <div
          className={styles["f-listFilter__criteria-search-btn"]}
          onClick={handleSubmit}
        >
          <FontAwesomeIcon icon={["fal", "search"]} />
        </div>
      </div>
    </div>
  );
};

export default AdminSearchWidget;
